<template>
  <div>
    <div class="header-video">
      <img :src="loadUrl.vps_img" />
      <div class="video-text">
        <div class="logo-text">
          <span>混空Studio</span>
        </div>
        <div class="link-room">AI+AR元宇宙内容创作与分发</div>
        <a class="experience-now" href="https://mixedspace.njyjxr.com">
          <span>立即体验</span>
          <div class="experience-btn"></div>
        </a>
      </div>
    </div>
    <div class="role-wrap">
      <div class="title">专业的元宇宙智能创作工具</div>
      <div class="title-tips">智能生成数字空间&nbsp;&nbsp;智能创作工具链&nbsp;&nbsp;跨端智能互动体验</div>
      <div class="role-scene">
        <div v-for="(item, index) in roleTextList" :key="index"
          :class="activeRoleIndex == index ? item.activeClass : ''" @click="activeRoleIndex = index">
          <div class="role-title">{{ item.title }}</div>
          <div class="role-title-tips">{{ item.tips }}</div>
          <img :src="item.url" :class="index == 1 ? 'rokid' : ''">
        </div>
      </div>
      <div class="title">多种识别方式，更灵活、更有趣</div>
      <div class="single-point">
        <div class="title-sub">单点AR服务</div>
        <div class="single-box">
          <div v-for="(item, index) in singlePointDataList" :key="index">
            <div class="scene-type">{{ item.name }}</div>
            <div class="scene-text">
              <div>{{ item.content[0] }}</div>
              <div>{{ item.content[1] }}</div>
            </div>
            <div class="scene-content">
              <img v-if="item.url" :src="item.url" />
            </div>
          </div>
        </div>
        <div class="title-sub">空间AR服务</div>
        <div class="spatial-recognition">
          <div>
            <div class="list-icon">扫描空间特征</div>
            <div class="list-icon">识别成功后，在立体空间中出现虚拟</div>
            <div>互动内容</div>
            <div class="list-icon">随着用户的位置移动展现出不同的内</div>
            <div>容场景</div>
          </div>
          <div class="item-show">
            <img v-if="loadUrl.room_recognition" :src="loadUrl.room_recognition" />
          </div>
        </div>
      </div>
    </div>
    <div class="advantage">
      <div class="title deep">我们的优势</div>
      <div class="title-tips deep">更低的创作门槛，更丰富的功能</div>
      <div class="m1">
        <div>
          <img class="m1-img" src="@/assets/images/studio/m1-l.png" />
          <div class="t1">更准确的空间定位</div>
          <div class="t2">自研空间定位算法，厘米级视觉定位空间导航精准， 支持大空间定位</div>
        </div>
        <div>
          <img src="@/assets/images/studio/m1-r.png" />
          <div class="t1">更快速的交付部署</div>
          <div class="t2">SaaS化服务快速调整内容布局</div>
          <div class="t2">2天内完成空间构建现场体验式交付</div>
        </div>
      </div>
      <div class="m2">
        <img class="img2" src="@/assets/images/studio/m2-l.png" />
        <img class="img1" src="@/assets/images/studio/m2-m.png" />
        <img class="img3" src="@/assets/images/studio/m2-r.png" />
        <div class="t1">更简单的场景创作</div>
        <div class="t2">3D场景地图，可视化交互智能创作，所“建”即所得</div>
      </div>
      
      <div class="m4">
        <img class="img2" src="@/assets/images/studio/m4tupian1.png" />
        <img class="img1" src="@/assets/images/studio/m4tupian.png" />
        <div class="t1">AI创作功能</div>
        <div class="t2">AI一键生成内容素材，畅享无限创作</div>
      </div>
      
      <div class="m3">
        <div>
          <div class="m3-icons">
            <img src="@/assets/images/studio/m3-l-1.png" />
            <img src="@/assets/images/studio/m3-l-2.png" />
            <img src="@/assets/images/studio/m3-l-3.png" />
          </div>
          <div class="t1">更多平台支持应用</div>
          <div class="t2">XR/VR眼镜、移动端APP、小程序AR、Web AR</div>
        </div>
        <div>
          <div class="m3-r">
            <img src="@/assets/images/studio/m3-r-t.png" />
            <img src="@/assets/images/studio/m3-r-b.png" />
          </div>
          <div class="t1">更强的内容扩展性</div>
          <div class="t2">数字多媒体动画、特效手势互动、3D数字人</div>
        </div>
      </div>
    </div>
    <div class="solution">
      <div class="title">混空Studio使用教程</div>
      <div class="title-tips">AI+AR元宇宙创作智能体，轻松实现AR创作与开发</div>
      <div class="solution-content">
        <div class="title-tab">
          <div v-for="(item, index) in solutionBannerList" :key="index"
            :class="(solutionActiveIndex == index ? 'active' : '') + (index == 99 ? ' no-list' : '') + (index == 1 ? ' op-list' : '')"
            @click="changeSolution(Number(index))">
            <img :src="solutionActiveIndex == index ? item.a_url : item.url" />
            <span>{{ item.title }}</span>
            <div v-if="solutionActiveIndex == index">
              <div v-for="(e, i) in item.content" :key="i">{{ e }}</div>
            </div>
            <div v-if="solutionActiveIndex == index" class="line"></div>
          </div>
        </div>
        <div>
          <div class="explanation-video" :style="{ opacity: solutionActiveIndex == index ? 1 : 0 }"
            v-for="(item, index) in solutionBannerList" :key="index">
            <img v-if="item.i_url" :src="item.i_url" />
            <video v-if="item.v_url" :src="item.v_url" autoplay loop muted playsinline webkit-playsinline></video>
          </div>
        </div>
      </div>
    </div>
    <div class="package">
      <div class="title deep">按需选择 灵活购买</div>
      <div class="title-tips deep">混空Studio产品体系</div>
      <div class="package-list">
        <div>
          <div>空间AR服务</div>
          <div class="suv-title2">标准服务包含</div>
          <div class="service-content">
            <div>
              <span>定位面积</span>
              <span>服务时长</span>
              <span>并发数量</span>
              <span>作品数量</span>
            </div>
            <div>
              <span>小程序访问次数</span>
              <span>素材空间容量</span>
            </div>
          </div>
          <div class="suv-title2">功能包含</div>
          <div class="function-box">
            <div>全平台空间定位功能</div>
            <div>XR眼镜端</div>
            <div>移动端</div>
            <div>微信小程序</div>
          </div>
          <div class="contact-btn" @click="toContact()">立即咨询</div>
          <div class="contact-tips">可根据您的作品实际情况，购买标准服务（支持按需扩展单项），详询混空商务</div>
        </div>
        <div>
          <div>单点AR服务</div>
          <div class="suv-title2">标准服务包含</div>
          <div class="service-content">
            <div>
              <span>单点AR识别</span>
              <span>服务时长</span>
              <span>作品数量</span>
            </div>
            <div>
              <span>小程序访问次数</span>
              <span>素材空间容量</span>
            </div>
          </div>
          <div class="suv-title2">功能包含</div>
          <div class="function-box">
            <div>平面AR</div>
            <div>图像AR</div>
            <div>单场景AR</div>
            <div>人脸AR</div>
            <div>身体AR</div>
            <div>手势AR</div>
          </div>
          <div class="contact-btn" @click="toContact()">立即咨询</div>
          <div class="contact-tips">可根据您的作品实际情况，购买标准服务（支持按需扩展单项），详询混空商务</div>
        </div>
      </div>
    </div>
    <contact-us v-if="store.state.contactUsTop"></contact-us>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, onUnmounted, nextTick, watch } from 'vue'
import ContactUs from '@/components/ContactUs2.vue'
import router from '@/router';
import { asynchronousRetrieval } from '@/utils'
import store from '@/store';

const loadUrl: any = ref({})
let videoDom: any = null;
const singlePointDataList = ref([
  {
    name: '平面AR',
    content: ['小程序扫描地面或者平面，', '识别后出现虚拟互动内容。'],
    url: ''
  },
  {
    name: '图像AR',
    content: ['小程序扫描特定的图片，', '识别后出现虚拟互动内容。'],
    url: ''
  },
  {
    name: '单场景AR',
    content: ['小程序扫描特定的单个小场景特征，', '识别后出现虚拟互动内容。'],
    url: ''
  },
  {
    name: '身体AR',
    content: ['小程序扫描人的身体形态，', '识别后出现虚拟互动内容。'],
    url: ''
  },
  {
    name: '人脸AR',
    content: ['小程序扫描人脸，', '识别后出现虚拟互动内容。'],
    url: ''
  },
  {
    name: '手势AR',
    content: ['小程序扫描张开的手掌，', '识别后出现虚拟互动内容。'],
    url: ''
  }
]);
const roleTextList = ref(
  [
    {
      title: '构建AR大场景',
      tips: 'SAAS化部署，无缝开发沉浸式世界里的增强现实内容，所有这些都在您的网络浏览器中创建和部署。',
      url: require('@/assets/images/home/room-platform.png'),
      activeClass: 'room-bg'
    },
    {
      title: 'XR眼镜端',
      tips: '通过账号进行登陆并选择相应场景进入相关展示内容。根据现场虚与实的融合进行体验。',
      url: require('@/assets/images/home/ar-rokid.png'),
      activeClass: 'glass-bg'
    },
    {
      title: '移动端',
      tips: '游客模式使用移动端混空Studio\nAPP或混空微信小程序进行空间互动体验(设备需支持ARkit/ARcore)。',
      url: loadUrl.value.web_platform,
      activeClass: 'web-bg'
    }
  ]
)
const activeRoleIndex = ref(0)
const solutionBannerList: any = ref(
  [
    {
      title: '空间数字化建图',
      content: ['多源采集：支持多种采集设备', '自研VPS定位：实现厘米级视觉定位精度','自研采集软件：空间瞬采，高效便捷'],
      url: require('@/assets/images/studio/solution-l-icon1.png'),
      a_url: require('@/assets/images/studio/solution-l-icon1A.png'),
    },
    {
      title: '智能场景创作',
      content: ['零代码，可视化操作', 'AI一键生成内容素材，创意无限', '20+类丰富素材，自由取用'],
      url: require('@/assets/images/studio/solution-l-icon2.png'),
      a_url: require('@/assets/images/studio/solution-l-icon2A.png'),
    },
    {
      title: '跨端部署',
      content: ['多形态交付：智能眼镜、手机等多端部署', '实时数据同步：可远程更新，内容动态迭代'],
      url: require('@/assets/images/studio/solution-l-icon3.png'),
      a_url: require('@/assets/images/studio/solution-l-icon3A.png'),
    },
    {
      title: '数实融合体验',
      content: ['多端体验数实融合互动场景'],
      url: require('@/assets/images/studio/solution-l-icon4.png'),
      a_url: require('@/assets/images/studio/solution-l-icon4A.png'),
    }
  ]
)
const solutionActiveIndex = ref(1)

let timer: any = null;
let lineStep = 1;

const toContact = () => {
  let contactUsTop: any = store.state.contactUsTop;
  contactUsTop = {
    bottom: 605 + 'rem'
  }
  store.state.contactUsTop = JSON.parse(JSON.stringify(contactUsTop))
}

const changeSolution = (index: number) => {
  solutionActiveIndex.value = index;
  tutorialCarousel()
}

const scrollEvent = () => {
  const screenRatio = (window.innerWidth / 1920);
  //m1
  const m1: any = document.querySelector('.advantage .m1');
  if (m1.getBoundingClientRect().top < window.innerHeight / 3 * 2) {
    (document.querySelector('.m1 .m1-img') as any).style.top = '33rem'
  }

  // m2
  const m2: any = document.querySelector('.advantage .m2');
  if (m2.getBoundingClientRect().top < window.innerHeight / 3 * 2) {
    (document.querySelector('.m2 .img1') as any).style.top = '19rem';
    (document.querySelector('.m2 .img2') as any).style.left = '94rem';
    (document.querySelector('.m2 .img3') as any).style.right = '72rem';
  }

  // m4
  const m4: any = document.querySelector('.advantage .m4');
  if (m4.getBoundingClientRect().top < window.innerHeight / 3 * 2) {
    const m4Img1 = document.querySelector('.m4 .img1') as any;
    const m4Img2 = document.querySelector('.m4 .img2') as any;
    const m4Img3 = document.querySelector('.m4 .img3') as any;
    
    if (m4Img1) m4Img1.style.top = '40rem';
    if (m4Img2) m4Img2.style.left = '30rem';
    if (m4Img3) m4Img3.style.right = '72rem';
  }

  // m3
  const m3: any = document.querySelector('.advantage .m3');
  const m3Top = m3.getBoundingClientRect().top
  const m3_r_child = document.querySelectorAll('.m3-r img');
  if (m3Top < window.innerHeight && m3Top > 0) {
    const offsetValue = (60 * screenRatio) * (m3Top / window.innerHeight);
    m3_r_child.forEach((e: any, i: number) => {
      if (i % 2) {
        e.style.marginLeft = -offsetValue + 'px'
      } else {
        e.style.marginLeft = offsetValue + 'px'
      }
    })
  }
}

const tutorialCarousel = () => {
  lineStep = 1;
  const line: any = document.querySelector('.solution-content .active .line');
  line.style.width = (380 / 5) * lineStep + 'rem';
  clearInterval(timer)
  timer = setInterval(() => {
    if (lineStep > 5) {
      solutionActiveIndex.value += 1;
      if (solutionActiveIndex.value > 3) {
        solutionActiveIndex.value = 0
      }
      lineStep = 1;

    }
    nextTick(() => {
      const line: any = document.querySelector('.solution-content .active .line');
      line.style.width = (380 / 5) * lineStep + 'rem';
      lineStep++;
    })

  }, 1050)
}

watch(() => solutionActiveIndex.value, (newState) => {
  if (solutionBannerList.value[newState].v_url) {
    videoDom = document.querySelectorAll('.explanation-video')[newState]?.children[0];
    videoDom.pause();
    setTimeout(() => {
      videoDom?.play();
    }, 200)
  }
})

onMounted(async () => {
  window.addEventListener('scroll', scrollEvent, false)
  tutorialCarousel()

  const vps_img: any = await asynchronousRetrieval('webimg/images/vps-img2.png');
  const web_platform: any = await asynchronousRetrieval('webimg/images/home/web-platform.png');
  const collect_maps: any = await asynchronousRetrieval('webimg/video/collect-maps.gif');
  const creating_scenes: any = await asynchronousRetrieval('webimg/video/creating-scenes.gif');
  const rapid_deployment: any = await asynchronousRetrieval('webimg/images/studio/rapid-deployment.png');
  const virtual_real_fusion: any = await asynchronousRetrieval('webimg/gif/virtual-real-fusion.gif');
  const glass_platform_bg: any = await asynchronousRetrieval('webimg/images/home/glass_platform_bg.png');
  const plane_recognition: any = await asynchronousRetrieval('webimg/images/studio/plane-recognition.gif');
  const hand_recognition: any = await asynchronousRetrieval('webimg/images/studio/hand-recognition.gif');
  const single_scene: any = await asynchronousRetrieval('webimg/images/studio/single-scene.gif');
  const body_recognition: any = await asynchronousRetrieval('webimg/images/studio/body-recognition.gif');
  const image_recognition: any = await asynchronousRetrieval('webimg/images/studio/image-recognition.gif');
  const face_recognition: any = await asynchronousRetrieval('webimg/images/studio/face-recognition.gif');
  const room_recognition: any = await asynchronousRetrieval('webimg/gif/room.gif');
  loadUrl.value = { vps_img, web_platform, collect_maps, creating_scenes, rapid_deployment, virtual_real_fusion, glass_platform_bg, hand_recognition, single_scene, body_recognition, image_recognition, face_recognition, room_recognition }

  roleTextList.value[2].url = web_platform;
  solutionBannerList.value[0].i_url = collect_maps;
  solutionBannerList.value[1].i_url = creating_scenes;
  solutionBannerList.value[2].i_url = rapid_deployment;
  solutionBannerList.value[3].i_url = virtual_real_fusion;
  singlePointDataList.value[0].url = plane_recognition;
  singlePointDataList.value[1].url = image_recognition;
  singlePointDataList.value[2].url = single_scene;
  singlePointDataList.value[3].url = body_recognition;
  singlePointDataList.value[4].url = face_recognition;
  singlePointDataList.value[5].url = hand_recognition;
})

onUnmounted(() => {
  clearInterval(timer)
  window.removeEventListener('scroll', scrollEvent, false)
})
</script>
<style scoped lang="less">
.title {
  font-weight: 600;
  font-size: 61rem;
  color: #FFFFFF;

  &.deep {
    color: #000;
  }
}

.title-tips {
  font-weight: 500;
  font-size: 32rem;
  color: #FFFFFF;
  margin-top: 24rem;
  margin-bottom: 47rem;

  &.deep {
    color: #000;
  }
}

.header-video {
  position: relative;
  width: 100%;
  height: 44.79vw;
  position: relative;
  background-size: 100% 100%;
  background: #348AD7;

  img {
    width: 39.92vw;
    height: auto;
    object-fit: fill;
    position: absolute;
    right: 6.78vw;
    top: 3.33vw;
  }

  .video-text {
    width: 58.33vw;
    position: absolute;
    top: 14.73958vw;
    left: 50%;
    margin-left: -29.167vw;
    font-size: 1.0417vw;
    color: #FFFFFF;
    text-align: left;

    .logo-text {
      font-weight: 600;
      font-size: 4.167vw;
      color: #FFFFFF;
    }

    .link-room {
      font-size: 2.1354vw;
      color: #FFFFFF;
      margin-top: 1.0417vw;
    }

    .experience-now {
      width: 9.479vw;
      height: 3.3854vw;
      background: #fff;
      border-radius: 1.71875vw;
      margin-top: 6.75vw;
      padding: 0 0.36458vw 0 1.25vw;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      text-decoration: none;
      color: #0675FF;
      font-weight: bold;

      .experience-btn {
        width: 2.604vw;
        height: 2.604vw;
        background: url(~@/assets/images/next-icon2.png);
        background-size: 100% 100%;
      }
    }
  }
}

.role-wrap {
  // width: 1920rem;
  height: 3357rem;
  background: #242424;
  padding-top: 116rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .role-scene {
    width: 1228rem;
    height: 524rem;
    font-size: 0;
    margin-bottom: 130rem;

    &>div {
      position: relative;
      width: 361rem;
      height: 524rem;
      background: #303030;
      border-radius: 24rem;
      border: 1px solid #979797;
      display: inline-block;
      margin-left: -55rem;
      padding-top: 62rem;
      box-sizing: border-box;
      padding-right: 55rem;
      vertical-align: middle;
      transition: all .5s;
      border: 8px solid #303030;
      cursor: pointer;

      &::after {
        content: '';
        width: calc(100% + 14px);
        height: calc(100% + 14px);
        border: 1px solid #979797;
        position: absolute;
        left: -8px;
        top: -8px;
        border-radius: 24rem;
        transition: none;
        z-index: 0;
      }

      .role-title {
        font-weight: 500;
        font-size: 32rem;
        color: #FFFFFF;
        text-align: left;
        padding-left: 47rem;
      }

      .role-title-tips {
        font-weight: 500;
        font-size: 16rem;
        color: rgba(255, 255, 255, 0.6);
        width: 198rem;
        margin-top: 24rem;
        margin-left: 47rem;
        margin-bottom: 70rem;
        text-align: left;
        text-align: justify;
      }

      .rokid {
        width: 240rem;
        margin-top: 30rem;
        height: auto;
      }

      img {
        width: 280rem;
        height: 238rem;
      }
    }

    .room-bg,
    .glass-bg,
    .web-bg {
      width: 562rem;
      background-image: url(~@/assets/images/home/room-platform-bg.png);
      background-size: 100% 100%;
      border: 8px solid #000;
      background-color: #303030;

      &>div {
        color: #fff;
      }
    }

    .glass-bg {
      background-image: url('@/assets/images/home/glass-platform-bg.png');
      background-size: 100% 100%;
    }

    .web-bg {
      width: 505rem !important;
      background-image: url(~@/assets/images/home/web-platform-bg.png);
      background-size: 100% 100%;
    }

    &>div:first-child {
      margin-left: 0;
    }

    &>div:last-child {
      width: 304rem;
      padding-right: 0;
    }
  }

  .single-point {
    width: 1110rem;
    margin-top: 52rem;

    .title-sub {
      font-weight: 500;
      font-size: 32rem;
      color: #FFFFFF;
      text-align: left;
      width: 100%;
      margin-bottom: 24rem;
    }

    .single-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
      margin-bottom: 99rem;

      &>div {
        width: 362rem;
        height: auto;
        background: #1B1B1B;
        border-radius: 24rem 24rem 24rem 24rem;
        border: 1px solid rgba(255,255,255,0.2);
        margin-top: 12rem;
        box-sizing: border-box;
        padding: 36rem 44rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        .scene-type {
          font-weight: 500;
          font-size: 24rem;
          color: #FFFFFF;
          margin-bottom: 20rem;
        }

        .scene-text {
          font-weight: 500;
          font-size: 16rem;
          color: #B2B2B2;
          line-height: 1.5;
          margin-bottom: 20rem;
          text-align: left;
        }

        .scene-content {
          width: 274rem;
          height: auto;
          border-radius: 12rem;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            display: block;
          }
        }
      }
    }

    .spatial-recognition {
      width: 1110rem;
      height: 505rem;
      background: #1B1B1B;
      border-radius: 24rem;
      border: 1px solid rgba(255,255,255,0.2);
      box-sizing: border-box;
      padding: 64rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 24rem;
      color: #FFFFFF;
      text-align: left;
      line-height: 1.5;
      font-weight: 400;

      .list-icon {
        position: relative;

        &::before {
          content: '';
          width: 7.7rem;
          height: 7.7rem;
          border-radius: 100% 100%;
          background-color: #D9D9D9;
          position: absolute;
          left: -21rem;
          top: 15rem;
        }
      }

      .item-show {
        position: relative;
        width: 505rem;
        height: 377rem;
        border-radius: 12rem;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          position: absolute;
          right: 0;
          top: 0;
        }
        // background-color: #fff;
      }
    }
  }
}

.advantage {
  height: 2080rem;
  background: linear-gradient(180deg, #FFFFFF 0%, #E9EFF6 100%);
  padding-top: 112rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;

  &>div {
    margin-bottom: 24rem;
  }

  .title {
    margin-bottom: -5rem;
  }

  .title-tips {
    margin-bottom: 52rem;
  }

  .m1 {
    margin-top: 20rem;
    display: flex;
    justify-content: center;
    align-items: center;

    &>div {
      margin: 0 10rem;
    }

    &>div:first-child {
      width: 540rem;
      height: 344rem;
      background: #1F2A34;
      border-radius: 24rem;
      position: relative;
      font-weight: 500;
      padding: 230rem 120rem 0 41rem;
      box-sizing: border-box;
      overflow: hidden;

      img {
        width: 419rem;
        height: 277rem;
        position: absolute;
        // top: 33rem;
        left: 61rem;
        top: 500rem;
        transition: all 1s;
      }

      &>div {
        position: relative;
        z-index: 1;
        text-align: left;
      }

      &>div.t1 {
        font-size: 26rem;
        color: #FFFFFF;
      }

      &>div.t2 {
        font-size: 16rem;
        color: #C0C0C0;
        margin-top: 7rem;
      }

      &::after {
        content: '';
        width: 460rem;
        height: 183rem;
        background: linear-gradient(180deg, rgba(31, 42, 52, 0) 0%, rgba(31, 42, 52, 0.95) 50%, #1F2A34 100%);
        border-radius: 24rem;
        position: absolute;
        left: 29rem;
        bottom: 21rem;
      }
    }

    &>div:last-child {
      width: 380rem;
      height: 344rem;
      background: #FFFFFF;
      border-radius: 24rem;
      position: relative;
      padding: 230rem 0 0 39rem;
      box-sizing: border-box;
      font-weight: 500;
      text-align: left;

      img {
        width: 299rem;
        height: 154rem;
        position: absolute;
        top: 42rem;
        left: 39rem;
      }

      .t1 {
        font-size: 26rem;
        color: #000000;
        margin-bottom: 7rem;
      }

      .t2 {
        font-size: 16rem;
        color: #7F7F7F;
      }
    }
  }

  .m2 {
    width: 940rem;
    height: 416rem;
    background: url('@/assets/images/studio//m2-bg.png');
    background-size: 100% 100%;
    position: relative;
    padding: 319rem 0 0 41rem;
    font-weight: 500;
    box-sizing: border-box;
    text-align: left;
    overflow: hidden;

    .img1 {
     width: 600rem;
    height: 307rem;
    position: absolute;
    top: 500rem;
    left: 176rem;
    transition: all 1s;
    }

    .img2 {
     width: 120rem;
    height: 260rem;
    position: absolute;
    top: 40rem;
    z-index: 1;
    transition: all 1s;
    }

    .img3 {
      position: absolute;
      width: 182rem;
      height: 170rem;
      top: 186rem;
      // right: 72rem;
      right: -300rem;
      transition: all 1s;
    }

    .t1 {
      font-size: 26rem;
      color: #FFFFFF;
      margin-bottom: 7rem;
    }

    .t2 {
      font-size: 16rem;
      color: #C0C0C0;
    }
  }
 .m4 {
     width: 940rem;
     height: 416rem;
     background: #fff;
     background-size: 100% 100%;
     position: relative;
     padding: 319rem 0 0 41rem;
     font-weight: 500;
     box-sizing: border-box;
     text-align: left;
     overflow: hidden;
     border-radius: 24rem;
     .img1 {
         width: 530rem;
     height: 364rem;
     position: absolute;
     top: 500rem;
     left: 202rem;
     transition: all 1s;
     }
 
     .img2 {
    width: 876rem;
     height: 340rem;
     position: absolute;
     top: 1rem;
     left: 32rem;
     z-index: 1;
     transition: all 1s;
     }
 
     .t1 {
       font-size: 26rem;
       color: #000000;
       margin-bottom: 7rem;
     }
 
     .t2 {
       font-size: 16rem;
       color: #7F7F7F;
     }
   }

  .m3 {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;

    &>div {
      width: 460rem;
      height: 314rem;
      margin: 0 10rem;
      padding: 217rem 0 0 41rem;
      box-sizing: border-box;
      font-weight: 500;

      .t1 {
        font-size: 26rem;
        margin-bottom: 7rem;
      }
    }

    &>div:first-child {
      position: relative;
      background: #FFFFFF;
      border-radius: 24rem;

      .t1 {
        color: #000000;
      }

      .t2 {
        font-size: 16rem;
        color: #7F7F7F;
      }
    }

    &>div:last-child {
      background: url(~@/assets/images/studio/m3-r-bg.png);
      background-size: 100% 100%;
      position: relative;
      overflow: hidden;

      .t1 {
        color: #fff;
      }

      .t2 {
        font-size: 16rem;
        color: #C0C0C0;
      }
    }

    .m3-icons {
      width: 380rem;
      height: 110rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      left: 40rem;
      top: 57rem;

      img {
        width: 110rem;
        height: 110rem;
      }
    }

    .m3-r {
      position: relative;
      position: absolute;
      top: 54rem;
      left: 0;

      img {
        width: 568rem;
        height: 52rem;
        display: inline-block;
        position: absolute;
      }

      &>img:first-child {
        top: 0;
        left: 16rem;
      }

      &>img:last-child {
        top: 68rem;
        left: -70rem;
      }
    }
  }
}

.solution {
  height: 945rem;
  background: #232323;
  padding-top: 112rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  .solution-content {
    margin-top: 25rem;
    height: 484rem;
    display: flex;
    justify-content: center;
    align-items: center;

    &>div:not(.title-tab) {
      position: relative;
      width: 710rem;
      height: 484rem;
      border-radius: 30rem;
      overflow: hidden;
      border: 2px solid #bbb;
      font-size: 0;
      box-sizing: border-box;

      &>div {
        width: 710rem;
        height: 484rem;
        position: absolute;
        left: 0;
        top: 0;
      }

      img {
        position: relative;
        width: calc(100% + 4rem);
        height: calc(100% + 4rem);
        left: -2rem;
        top: -2rem;
      }

      video {
        position: relative;
        width: calc(100% + 4rem);
        height: calc(100% + 4rem);
        object-fit: fill;
        left: -2rem;
        top: -2rem;
      }
    }

    &>div:first-child {
      width: 380rem;
      text-align: left;
      margin-right: 30rem;

      &>div {
        margin-top: 47rem;
        padding-left: 16rem;
        box-sizing: border-box;
        cursor: pointer;
        color: #7F7F7F;
      }

      .active {
        position: relative;
        padding-top: 24rem;
        background: #181818;
        box-shadow: inset 0px -2rem 0px 0px #363636;
        border-radius: 2rem;
        // height: 136rem;
        box-sizing: border-box;
        margin-top: 24rem;
        padding-bottom: 20rem;

        &>span {
          color: #fff;
        }

        &.no-list>div:not(.line) {
          padding-left: 38rem;
        }

        &.no-list>div:not(.line)>div::before {
          content: none;
        }

        &.op-list>div:not(.line)>div::before {
          opacity: 1;
        }

        &>div:not(.line) {
          position: relative;
          text-align: left;
          margin-top: 8rem;
          font-weight: 400;
          font-size: 16rem;
          line-height: 24rem;
          padding-left: 68rem;

          &>div {
            position: relative;
          }

          &>div::before {
            content: '';
            width: 6rem;
            height: 6rem;
            background-color: #7F7F7F;
            position: absolute;
            left: -15rem;
            top: 8rem;
            border-radius: 50%;
          }
        }

        .line {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 0;
          border-bottom: 2px solid;
          height: 0;
          border-image: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(6, 117, 255, 1), rgba(6, 196, 255, 1)) 2 2;
        }
      }

      img {
        width: 34rem;
        height: 34rem;
        vertical-align: middle;
      }

      span {
        font-weight: 500;
        font-size: 24rem;
        color: #C1C1C1;
        vertical-align: middle;
        margin-left: 14rem;
      }
    }
  }
}

.package {
  height: 1180rem;
  background: linear-gradient(180deg, #FFFFFF 0%, #E9EFF6 100%);
  padding-top: 112rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .package-list {
    width: 1132rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 27rem;

    &>div {
      position: relative;
      width: 548rem;
      height: 725rem;
      background: rgba(255,255,255,0.32);
      box-shadow: 0px 4rem 20rem 0px rgba(0,0,0,0.06);
      border-radius: 24rem;
      border: 1px solid rgba(0,0,0,0.1);
      padding: 36rem 36rem 54rem;
      box-sizing: border-box;

      &:hover {
        border: 1px solid #0675FF;
      }

      &>div:first-child {
        font-weight: 500;
        font-size: 32rem;
        color: #000000;
        text-align: left;
        margin-bottom: 32rem;
      }

      .suv-title2 {
        font-weight: 500;
        font-size: 20rem;
        color: #000000;
        text-align: left;
        margin-bottom: 16rem;
      }

      .service-content {
        text-align: left;
        margin-bottom: 16rem;

        span {
          display: inline-block;
          font-weight: 400;
          font-size: 16rem;
          color: #0675FF;
          text-align: center;
          padding: 6rem 12rem;
          background: rgba(6,117,255,0.1);
          border-radius: 4rem;
          margin-right: 11rem;
          margin-bottom: 16rem;
        }
      }

      .function-box {
        font-weight: 400;
        font-size: 16rem;
        color: #4F4F4F;
        text-align: left;

        &>div {
          position: relative;
          margin-bottom: 12rem;
          padding-left: 22rem;

          &::before {
            content: '';
            width: 16rem;
            height: 16rem;
            background-image: url(~@/assets/images/studio/list-iconA.png);
            background-size: 100% 100%;
            position: absolute;
            left: 0;
            top: 4rem;
          }
        }
      }

      .contact-btn {
        width: 476rem;
        height: 80rem;
        line-height: 80rem;
        background: #0675FF;
        border-radius: 8rem;
        font-weight: 500;
        font-size: 24rem;
        color: #FFFFFF;
        position: absolute;
        bottom: 90rem;
        left: 36rem;
        cursor: pointer;
      }

      .contact-tips {
        font-weight: 400;
        font-size: 16px;
        color: #828282;
        position: absolute;
        bottom: 35rem;
        width: 100%;
        text-align: left;
        word-break: keep-all;
      }
    }
  }
}
</style>